import React from "react";
import { Grid, Typography, TextField } from "@material-ui/core";
import { ColorPicker } from "material-ui-color";

const ThresholdTierRow = ({ tierLabel, sectionName, label, value, onValueChange, color, onColorChange, disabled, isDefault, error, classes }) => {
  return (
    <>
      <Grid item xs={2} className={classes.flexCenter}>
        <Typography variant="body2" className={classes.tierLabel}>{tierLabel}</Typography>
      </Grid>
      <Grid item xs={8} className={classes.bottomMargin}>
        <TextField
          variant="outlined"
          size="small"
          type={isDefault ? "text" : "number"}
          label={label}
          fullWidth
          className={`${sectionName.replace(/\s+/g, "-").toLowerCase()}-${tierLabel.replace(/\s+/g, "-").toLowerCase()}`}
          value={isDefault ? "DEFAULT" : value}
          disabled={isDefault || disabled}
          InputLabelProps={{ shrink: true }}
          InputProps={isDefault ? { className: classes.defaultInput } : undefined}
          error={!!error}
          helperText={error}
          onChange={isDefault ? undefined : (e) => {
            let val = Number(e.target.value);
            if (val < 0) val = 0;
            onValueChange(val);
          }}
        />
      </Grid>
      <Grid item xs={2} className={classes.flexCenter}>
        <ColorPicker
          value={color}
          hideTextfield
          disabled={disabled}
          onChange={(e) => onColorChange?.("#" + e.hex)}
        />
      </Grid>
    </>
  );
};

export default ThresholdTierRow;
